export const formatMoney = (amount) => (
    Number.isInteger(amount) ? `$${amount}` : `$${amount.toFixed(2)}`
);

export const formatSignedMoney = (amount) => (
    `${amount < 0 ? '-' : ''}${formatMoney(Math.abs(amount))}`
);

export const formatFileSize = (bytes) => {
    if (!bytes) return '0 Bytes';
    const units = ['Bytes', 'KB', 'MB', 'GB'];
    const unitIndex = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    return `${parseFloat((bytes / (1024 ** unitIndex)).toFixed(2))} ${units[unitIndex]}`;
};
